export default __webpack_public_path__ + "static/media/08_cut_lists.00430f4c.png";